/* claude-acc.js — gallery + variant picker + add-to-cart for non-flagship PDPs.
   Deliberately independent of claude-pdp.js (which is hard-wired to the two saunas).
   Pairs with layout/claude-page.liquid, which already loads claude-page.js
   (burger drawer, FAQ accordion, .reveal observer). */
(function () {
  var C = window.CLAUDE_ACC || {};

  function money(cents) {
    var n = cents / 100;
    var s = n % 1 === 0 ? String(n) : n.toFixed(2);
    return '$' + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ---------------- gallery ---------------- */
  var main = document.getElementById('galMain');
  var thumbs = [].slice.call(document.querySelectorAll('.gal-thumbs button'));
  var counter = document.getElementById('galCount');
  var cur = 0;

  function show(i) {
    if (!thumbs.length || !main) return;
    cur = (i + thumbs.length) % thumbs.length;
    var t = thumbs[cur];
    main.src = t.getAttribute('data-full');
    main.alt = t.getAttribute('data-alt') || '';
    thumbs.forEach(function (el, k) { el.classList.toggle('is-active', k === cur); });
    if (counter) counter.textContent = (cur + 1) + ' / ' + thumbs.length;
    var strip = t.parentElement;
    if (strip) {
      var left = t.offsetLeft - strip.clientWidth / 2 + t.clientWidth / 2;
      strip.scrollTo({ left: left, behavior: 'smooth' });
    }
  }

  thumbs.forEach(function (t, k) {
    t.addEventListener('click', function () { show(k); });
  });

  var prev = document.getElementById('galPrev');
  var next = document.getElementById('galNext');
  if (prev) prev.addEventListener('click', function () { show(cur - 1); });
  if (next) next.addEventListener('click', function () { show(cur + 1); });

  document.addEventListener('keydown', function (e) {
    if (!thumbs.length) return;
    if (e.key === 'ArrowLeft') show(cur - 1);
    if (e.key === 'ArrowRight') show(cur + 1);
  });

  /* swipe on the main image */
  if (main) {
    var x0 = null;
    main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 42) show(dx < 0 ? cur + 1 : cur - 1);
      x0 = null;
    }, { passive: true });
  }

  if (thumbs.length && counter) counter.textContent = '1 / ' + thumbs.length;

  /* ---------------- variant picker ---------------- */
  var cards = [].slice.call(document.querySelectorAll('.vcard[data-vid]'));
  var elNow = document.getElementById('priceNow');
  var elWas = document.getElementById('priceWas');
  var elSave = document.getElementById('priceSave');
  var elFin = document.getElementById('finLine');
  var elNote = document.getElementById('vNote');
  var atc = document.getElementById('atcBtn');
  var atcLabel = document.getElementById('atcLabel');
  var atcSub = document.getElementById('atcSub');
  var sPrice = document.getElementById('stickyPrice');
  var sName = document.getElementById('stickyName');
  var current = null;

  function apply(card) {
    if (!card) return;
    current = card;
    cards.forEach(function (c) { c.classList.toggle('is-active', c === card); });

    var price = parseInt(card.getAttribute('data-price'), 10) || 0;
    var cmp = parseInt(card.getAttribute('data-cmp'), 10) || 0;
    var avail = card.getAttribute('data-avail') !== 'false';
    var sale = parseInt(C.sale, 10) || 0;
    var isDeposit = card.getAttribute('data-deposit') === 'true';

    var nowCents = price;
    var wasCents = 0;

    if (sale > 0 && !isDeposit && price > sale) {
      nowCents = price - sale;
      wasCents = price;
    } else if (cmp > price) {
      /* only ever render a strikethrough when compare-at is genuinely higher */
      wasCents = cmp;
    }

    if (elNow) elNow.textContent = money(nowCents);
    if (elWas) {
      elWas.textContent = wasCents ? money(wasCents) : '';
      elWas.style.display = wasCents ? '' : 'none';
    }
    if (elSave) {
      var diff = wasCents ? wasCents - nowCents : 0;
      elSave.textContent = diff > 0 ? 'Save ' + money(diff) : '';
      elSave.style.display = diff > 0 ? '' : 'none';
    }

    if (elFin) {
      var finText = card.getAttribute('data-fin');
      elFin.innerHTML = finText || '';
      elFin.style.display = finText ? '' : 'none';
    }
    if (elNote) {
      var note = card.getAttribute('data-note');
      elNote.innerHTML = note || '';
      elNote.style.display = note ? '' : 'none';
    }

    if (sPrice) sPrice.textContent = money(nowCents);
    if (sName) sName.textContent = card.getAttribute('data-name') || '';

    if (atc) {
      atc.setAttribute('data-vid', card.getAttribute('data-vid'));
      atc.disabled = !avail;
      atc.classList.toggle('is-sold', !avail);
      if (atcLabel) atcLabel.textContent = avail ? (card.getAttribute('data-cta') || 'Add to cart') : 'Sold out';
      if (atcSub) {
        atcSub.textContent = avail ? (card.getAttribute('data-sub') || '') : 'Email us to be notified when it is back';
      }
    }
  }

  cards.forEach(function (c) {
    c.addEventListener('click', function () {
      if (c.getAttribute('data-avail') === 'false') return;
      apply(c);
    });
  });

  if (cards.length) {
    var initial = cards.filter(function (c) { return c.getAttribute('data-avail') !== 'false'; })[0] || cards[0];
    apply(initial);
  }

  /* ---------------- quantity ---------------- */
  var qtyVal = document.getElementById('qtyVal');
  var q = 1;
  function setQty(n) {
    q = Math.max(1, Math.min(99, n));
    if (qtyVal) qtyVal.textContent = q;
  }
  var qMinus = document.getElementById('qtyMinus');
  var qPlus = document.getElementById('qtyPlus');
  if (qMinus) qMinus.addEventListener('click', function () { setQty(q - 1); });
  if (qPlus) qPlus.addEventListener('click', function () { setQty(q + 1); });

  /* ---------------- add to cart ---------------- */
  function addToCart(btn) {
    var id = btn.getAttribute('data-vid');
    if (!id || btn.disabled) return;
    var label = btn.querySelector('#atcLabel, .atc-label');
    var was = label ? label.textContent : '';
    if (label) label.textContent = 'Adding\u2026';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: q }] })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'That item could not be added.'); });
        return r.json();
      })
      .then(function () { window.location.href = '/cart'; })
      .catch(function (err) {
        btn.disabled = false;
        if (label) label.textContent = was;
        var box = document.getElementById('atcError');
        if (box) {
          box.textContent = err.message + ' Try again, or email info@sweatboxshop.com and we will place it for you.';
          box.style.display = 'block';
        }
      });
  }

  if (atc) atc.addEventListener('click', function () { addToCart(atc); });
  var sticky = document.getElementById('stickyAtc');
  if (sticky) {
    sticky.addEventListener('click', function () {
      if (atc) { sticky.setAttribute('data-vid', atc.getAttribute('data-vid')); addToCart(sticky); }
    });
  }

  /* ---------------- sticky mobile bar ---------------- */
  var bar = document.getElementById('stickyBar');
  var anchor = document.getElementById('buy');
  if (bar && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { bar.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0); });
    }, { threshold: 0 }).observe(anchor);
  }
})();
